import {
  spline,
  pointsInPath,
  createCoordsTransformer,
} from "https://cdn.skypack.dev/@georgedoescode/generative-utils@1.0.1";
import gsap from "https://cdn.skypack.dev/gsap@3.6.1";

(function (Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.contact_form = {
    attach: function (context, settings) {
      var selectElement = document.getElementById(
        "edit-field-votre-sujet",
        context
      );
      if (selectElement) {
        selectElement.addEventListener("change", function () {
          const colorMap = {
            make_application: "#ffe500",
            send_brief: "#ff0094",
            send_message: "#00cdff",
            _none: "#00cdff",
          };
          var key = this.value;
          var selectedColor = colorMap[key] || "#00cdff"; // Fallback color
          var circle = document.querySelector(
            ".contact-form-main_color-circle-container",
            context
          );
          if (circle) {
            circle.style.setProperty("--indicator-color", selectedColor);
          }
        });
        var selectElement = context.querySelector("#edit-field-votre-sujet");
        if (selectElement) {
          var firstOption = selectElement.querySelector(
            "option[value='_none']"
          );
          if (firstOption) {
            firstOption.setAttribute("disabled", "disabled");
          }
        }

        var noOpacity = document.querySelectorAll(
          '[data-drupal-selector^="edit-field-import-0-upload-"]'
        );
        noOpacity.forEach(function (element) {
          element.classList.add("no-opacity");
        });

        const circlePath = document.getElementById("mask-path");

        function createLiquidPath(path, options) {
          const svgPoints = pointsInPath(path, options.detail);
          const originPoints = svgPoints.map(({ x, y }) => ({ x, y }));
          const liquidPoints = svgPoints.map(({ x, y }) => ({ x, y }));

          const mousePos = { x: 0, y: 0 };
          const transformCoords = createCoordsTransformer(path.closest("svg"));

          const pointDistance = Math.hypot(
            originPoints[0].x - originPoints[1].x,
            originPoints[0].y - originPoints[1].y
          );
          const maxDist = {
            x: options.axis.includes("x") ? pointDistance / 4 : 0,
            y: options.axis.includes("y") ? pointDistance / 4 : 0,
          };

          gsap.ticker.add(() => {
            gsap.set(path, {
              attr: {
                d: spline(liquidPoints, options.tension, options.close),
              },
            });
          });

          document.addEventListener("mousemove", (e) => {
            const { x, y } = transformCoords(e);

            mousePos.x = x;
            mousePos.y = y;

            liquidPoints.forEach((point, index) => {
              const pointOrigin = originPoints[index];
              const distX = Math.abs(pointOrigin.x - mousePos.x);
              const distY = Math.abs(pointOrigin.y - mousePos.y);

              if (distX <= options.range.x && distY <= options.range.y) {
                const difference = {
                  x: pointOrigin.x - mousePos.x,
                  y: pointOrigin.y - mousePos.y,
                };

                const target = {
                  x: pointOrigin.x + difference.x,
                  y: pointOrigin.y + difference.y,
                };

                const x = gsap.utils.clamp(
                  pointOrigin.x - maxDist.x,
                  pointOrigin.x + maxDist.x,
                  target.x
                );

                const y = gsap.utils.clamp(
                  pointOrigin.y - maxDist.y,
                  pointOrigin.y + maxDist.y,
                  target.y
                );

                gsap.to(point, {
                  x: x,
                  y: y,
                  ease: "sine",
                  overwrite: true,
                  duration: 0.175,
                  onComplete() {
                    gsap.to(point, {
                      x: pointOrigin.x,
                      y: pointOrigin.y,
                      ease: "elastic.out(2, 0.5)",
                      duration: 2,
                    });
                  },
                });
              }
            });
          });
        }

        const prefersReducedMotionQuery = window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        );

        if (prefersReducedMotionQuery && !prefersReducedMotionQuery.matches) {
          createLiquidPath(circlePath, {
            detail: 32,
            tension: 0.01,
            close: true,
            range: {
              x: 200,
              y: 200,
            },
            axis: ["x", "y"],
          });
        }
      }

      // Formating phone number
      var phoneInput = document.getElementById(
        "edit-field-numero-de-telephone-0-value"
      );
      if (phoneInput) {
        phoneInput.addEventListener("input", function () {
          var value = phoneInput.value;
          value = value.replace(/\D/g, "");
          var formattedValue = value.replace(/(\d{2})(?=\d)/g, "$1 ");
          phoneInput.value = formattedValue;
        });
      }

      // Hover effects on blob
      var pictoLinkedIn = document.querySelector(".picto_linkedin");
      var pictoInstagram = document.querySelector(".picto_instagram");
      if (pictoLinkedIn && pictoInstagram) {
        var circle = document.querySelector(
          ".contact-form-main_contact-points_circle-filler"
        );
        pictoLinkedIn.addEventListener("mouseover", () => {
          if (circle) circle.classList.add("contact-form-main_fill-blue");
        });
        pictoLinkedIn.addEventListener("mouseout", () => {
          if (circle) circle.classList.remove("contact-form-main_fill-blue");
        });
        pictoInstagram.addEventListener("mouseover", () => {
          if (circle) circle.classList.add("contact-form-main_fill-pink");
        });
        pictoInstagram.addEventListener("mouseout", () => {
          if (circle) circle.classList.remove("contact-form-main_fill-pink");
        });
      }

      // Custom error on file field
      function handleErrors() {
        var file = document.querySelector(".file");
        var submitBtn = document.querySelector("#edit-submit");
        var subjectContainer = document.querySelector(
          ".form-item-field-votre-sujet"
        );
        var customErrorMessage = document.querySelector(
          ".custom-error-message"
        );
        var subjectErrorMessage = document.querySelector(
          ".subject-error-message"
        );
        var ogMessage = document.querySelector(".messages--error");

        if (ogMessage) {
          var errorText = ogMessage.textContent || ogMessage.innerText;

          if (errorText.includes("Le champ Votre sujet est requis")) {
            if (!subjectErrorMessage) {
              if (subjectContainer) {
                subjectContainer.insertAdjacentHTML(
                  "afterend",
                  '<p class="subject-error-message">Veuillez nous indiquer votre sujet.</p>'
                );
              }
            }
            ogMessage.remove();
          } else if (
            errorText.includes(
              "The answer you entered for the CAPTCHA was not correct"
            )
          ) {
            if (!customErrorMessage) {
              if (submitBtn) {
                submitBtn.insertAdjacentHTML(
                  "beforebegin",
                  '<p class="custom-error-message">Votre réponse au test Captcha est incorrecte.</p>'
                );
              }
            }
            ogMessage.remove();
          } else {
            if (customErrorMessage) {
              customErrorMessage.remove();
            }
            submitBtn.insertAdjacentHTML(
              "beforebegin",
              '<p class="custom-error-message">Fichier non supporté. Veuillez importer votre fichier aux formats pdf/doc/docx (8 mo max).</p>'
            );
          }
          ogMessage.remove();
        }
        if (customErrorMessage && file) {
          customErrorMessage.remove();
        }
      }

      const observer = new MutationObserver(() => {
        handleErrors();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      handleErrors();

      // Opacity on import file
      var file = document.querySelector(".file");
      var uploadBtn = document.querySelector(".js-form-type-managed-file");
      if (file) {
        uploadBtn.style.setProperty("--after-opacity", "20%");
        uploadBtn.classList.add("disable-hover");
      } else {
        uploadBtn.style.setProperty("--after-opacity", "100%");
        uploadBtn.classList.remove("disable-hover");
      }
      var inputElementByName = document.querySelector(
        'input[name="field_import_0_remove_button"]'
      );
      if (inputElementByName) {
        inputElementByName.value = "X";
      }
    },
  };
})(Drupal, drupalSettings);
